import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import styled from 'styled-components';

const WorklogTimerCellContainer = styled.div`
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

const WorklogTimespentCell = (props) => {
  const { cell } = props;
  const { revisedQuantity, billable } = cell?.row?.original;

  const getHours = (duration) => {
    const hours = Math.floor(duration / 60);
    return hours;
  };
  const getMinutes = (duration) => {
    const minutes = Math.round(duration % 60);
    return minutes;
  };

  const formatTime = (time) => {
    const timeInMinutes = time * 60;
    return `${getHours(timeInMinutes)}h ${getMinutes(timeInMinutes)}m`;
  };

  if (cell?.column?.accessor === 'nonBillable') {
    return !billable ? (
      <WorklogTimerCellContainer className="flex center">
        <div className="fx actr">{formatTime(revisedQuantity)}</div>
      </WorklogTimerCellContainer>
    ) : (
      <DisabledTag>--</DisabledTag>
    );
  }

  return cell?.value ? (
    <WorklogTimerCellContainer className="flex center">
      <div className="fx actr">{formatTime(revisedQuantity)}</div>
    </WorklogTimerCellContainer>
  ) : (
    <DisabledTag>--</DisabledTag>
  );
};

export default WorklogTimespentCell;
